import * as React from 'react';
import { useSelector, useDispatch } from "react-redux";
import '../styles.css';
import { TextField, InputAdornment, ThemeProvider, createTheme, Popper, InputLabel, Box } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import Stack from '@mui/material/Stack';
import Autocomplete from '@mui/material/Autocomplete';
import { colors } from '../../../common/pallette/colors';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { AvatarAndName } from '../../AvatarAndName';
import { baseUrl } from '../../../api/config';

const CustomPopper = styled(Popper)({
  '& .MuiAutocomplete-listbox': {
    fontSize: '14px',
  },
});

export default function TableSingleSelectBox(props: any) {
  const { placeholder, 
    selectedValue, 
    options, 
    variant, 
    keyLabel, 
    label, 
    textColor,
    handleChange, 
    handleInputChange,
    inputValue,
    fullList,
    showAvatar } = props;

  const theme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            padding: '0px 14px !important'
          }
        }
      },
      MuiStack: {
        styleOverrides: {
          root: {
            width: '100% !important'
          }
        }
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            fontSize: '12px'
          }
        }
      },
      MuiInput: {
        styleOverrides: {
          root: {
            '&::after': {
              borderBottom: '0px'
            },
            '&::before': {
              borderBottom: '0px'
            },
            '&:hover:not(.Mui-disabled, .Mui-error)::before': {
              borderBottom: 'none'
            }
          },
          input: {
            color: textColor
          }
        }
      },
      MuiAutocomplete: {
        styleOverrides: {
          root: {
            backgroundColor: 'transparent',
          }
        }
      }
    }
  });

  const fetchUserAvatars = (userId:any) => {
    const tempObj = fullList.find((d:any) => d.id == userId);
    if (tempObj) {
      return tempObj.avatarPath ? `${baseUrl}/Content${tempObj.avatarPath}` : ''
    } else {
      return '';
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Box>
        <Stack spacing={1} sx={{ '& > :not(style) ~ :not(style)': { marginTop: '0px' } }}>
          {label && <InputLabel className='fs12' sx={{ textAlign: 'left' }}>{label}</InputLabel>}
          <Autocomplete
            freeSolo
            className='fs12'
            value={selectedValue}
            inputValue={inputValue ? inputValue : ''}
            onChange={handleChange}
            onInputChange={handleInputChange}
            options={options}
            getOptionLabel={(option) => {
              if (typeof option === 'object' && option !== null) {
                return keyLabel && option[keyLabel] ? option[keyLabel] : '';
              } else {
                return inputValue;
              }
            }}
            renderOption={(props, option) => (
              <li {...props}>
                <AvatarAndName
                    avatarSize={18}
                    avatarName={option[keyLabel]} 
                    avatarImage={option.avatarPath && showAvatar ? `${baseUrl}/Content${option.avatarPath}` : ''}/>
              </li>
            )}
            sx={{ border: 0 }}
            PopperComponent={CustomPopper}
            renderInput={(params) => {
                return (
                  <Box sx={{ display: 'flex' }}>
                    {
                      showAvatar &&
                      <AvatarAndName
                      avatarSize={18}
                      avatarImage={fetchUserAvatars(selectedValue?.userId)}/>
                    }
                    <TextField
                      {...params}
                      sx={{ border: 0 }}
                      placeholder={placeholder || "Search"}
                      className='fs12'
                      variant={variant || 'outlined'}
                      InputProps={{
                        ...params.InputProps,
                        type: 'search',
                      }}
                    />
                  </Box>
                );
            }}
          />
        </Stack>
      </Box>
    </ThemeProvider>
  );
}
